export const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const frames = Math.floor((time % 1) * 240); // Always use 240fps for frame display
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${frames.toString().padStart(3, '0')}`;
};

export const validateVideoFile = async (file: File): Promise<{ valid: boolean; fps?: number }> => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('video/')) {
      reject(new Error('選択されたファイルは動画ファイルではありません。'));
      return;
    }

    if (file.size > 500 * 1024 * 1024) {
      reject(new Error('ファイルサイズが大きすぎます（最大500MB）。'));
      return;
    }

    const video = document.createElement('video');
    video.preload = 'metadata';

    const cleanup = () => {
      URL.revokeObjectURL(video.src);
      video.remove();
    };

    video.onloadedmetadata = () => {
      // Try to detect FPS using requestVideoFrameCallback if available
      if ('requestVideoFrameCallback' in video) {
        let lastTime = 0;
        let frameCount = 0;
        let fpsSum = 0;
        let measurements = 0;
        
        const callback: VideoFrameRequestCallback = (now, metadata) => {
            const timeDiff = metadata.mediaTime - lastTime;
            if (timeDiff > 0) {
              const currentFps = 1 / timeDiff;
              fpsSum += currentFps;
              measurements++;
              
              if (measurements >= 10) {
                const averageFps = Math.round(fpsSum / measurements);
                cleanup();
                resolve({ valid: true, fps: averageFps });
                return;
              }
            }
          
          lastTime = metadata.mediaTime;
          frameCount++;
          video.requestVideoFrameCallback(callback);
        };
        
        video.requestVideoFrameCallback(callback);
        // Start playback to trigger frame callbacks
        video.play().catch(() => {
          // Fallback if playback fails
          cleanup();
          resolve({ valid: true, fps: 240 }); // Default to 240fps if detection fails
        });
      } else {
        // Fallback for browsers without requestVideoFrameCallback
        cleanup();
        resolve({ valid: true, fps: 240 });
      }
    };

    video.onerror = () => {
      cleanup();
      reject(new Error('この動画形式はサポートされていません。'));
    };

    video.src = URL.createObjectURL(file);
  });
};